import setVehicleImageUrl from "action/garage/setVehicleImageUrl";
import { openModal } from "action/modal/openModal";
import { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import NextImage from "component/design-system/images/NextImage";
import PAImage from "component/design-system/images/PAImage";
import PAText, {
  FONT_SIZE,
} from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import ChangeVehicleButton from "modules/fitment/change-select-vehicle/ChangeVehicleButton";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isTires } from "util/category/is-tires";
import { isWheels } from "util/category/is-wheels";
import getDefaultVehicleImage, { defaultVehicleImageSrc } from "util/helper/getDefaultVehicleImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import getVehicleImageUrl from "util/helper/getVehicleImageUrl";
import HideIf from "util/HideIf";
import { toLowerCase } from "util/lodash/toLowerCase";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import styles from "./categoryVehicleBannerSection.module.scss";

function CategoryVehicleBannerSection() {
  const { selectedVehicle, vehicleImageUrl } = useSelector((state: RootState) => state.garage);
  const { urlInformation } = useSelector((state: RootState) => state.utils);
  const router = useRouter();
  const { query, asPath } = router;
  const category = toLowerCase(urlInformation?.tier1) || toLowerCase(query?.tier1);
  const isWheelsorTiresCategory = isTires(category) || isWheels(category);
  const vehicleDes = createVehicleDescription(selectedVehicle, false, false, isWheelsorTiresCategory);
  const dispatch = useDispatch();

  const defaultImage = getDefaultVehicleImage(selectedVehicle);
  const showColorPicker = vehicleImageUrl !== defaultImage;
  const isShopByCategory = asPath === "/all-parts";

  useEffect(() => {
    if (vehicleImageUrl || isShopByCategory) {
      getVehicleImageUrl({ vehicle: selectedVehicle, vehicleImageUrl }).then((url) => {
        dispatch(setVehicleImageUrl(url));
      });
    }
  }, [selectedVehicle, vehicleImageUrl]);

  if (validateVehicle(selectedVehicle)) {
    return (
      <>
        <div className={styles.vehicle_image_container_mobile}>
          <div className={styles.vehicle_images}>
            <div className={styles.vehicle_image_box}>
              <HideIf show={showColorPicker}>
                <div
                  onClick={() => dispatch(openModal("vehicleColorModal"))}
                  className={styles.color_picker}
                >
                  <PAImage
                    src={getRelativeImagePath(
                      "/cms/pubicImages/images/colorpicker.webp",
                    )}
                    width={20}
                    height={20}
                    alt="colorpicker"
                  />
                </div>
              </HideIf>
              <NextImage
                src={vehicleImageUrl}
                width={350}
                height={182}
                fallbackSrc={defaultVehicleImageSrc}
                alt={vehicleDes}
              />
            </div>
          </div>
          <div className={styles.vehicle_description_container}>
            <div className={styles.vehicle_description}>
              <div className={styles.make_image_container}>
                <PAImage
                  src={createMakeImageSource(selectedVehicle)}
                  width={40}
                  height={40}
                  alt={selectedVehicle?.make || "vehicle make"}
                />
              </div>
              <div>
                <PAText component="p" className="m-b-0" fontSize={FONT_SIZE[0]}>Shopping for:</PAText>
                <PAText component="p" className="m-b-0" bold fontSize={FONT_SIZE[3]} data-testid="category-vehicle-description">
                  {vehicleDes}
                </PAText>
              </div>
            </div>
            <ChangeVehicleButton
              defaultButtonType={BUTTON_TYPE.PRIMARY}
            />
          </div>
        </div>
      </>
    );
  }

  return null;
}

export default CategoryVehicleBannerSection;
